export const navigationInit = {
  curr: "Home",
};
